import { FunctionComponent } from 'react'
import styled from 'styled-components'
import { styles } from '../../../../styles/themes/style'
import TooltipWrapper from '../../../../components/TooltipWrapper'
import PricingIcon from './PricingIcon'
import { IPricingFeature } from '../pricingV2Content'

interface IPlanFeatureListProps {
    features: IPricingFeature[]
}

const PlanFeatureList: FunctionComponent<IPlanFeatureListProps> = ({ features }) => (
    <List>
        {features.map((feature, index) => (
            <Item key={index}>
                <CheckIcon type="check" />
                <TooltipWrapper tooltipText={feature.tooltip} placement="top" textAlignment="left">
                    <FeatureText tabIndex={0}>
                        {feature.segments.map((segment, segmentIndex) => segment.bold
                            ? <strong key={segmentIndex}>{segment.text}</strong>
                            : <span key={segmentIndex}>{segment.text}</span>)}
                    </FeatureText>
                </TooltipWrapper>
            </Item>
        ))}
    </List>
)

const List = styled.ul`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 11px;
    margin: 0;
    padding: 20px 0 0 0;
    list-style: none;
    border-top: 1px solid ${styles.colors.black200};
`
// flex-start + icon offset ((line-height - icon) / 2) keeps the check on the first line when the text wraps
const Item = styled.li`
    display: flex;
    align-items: flex-start;
    gap: 8px;
    font-family: NunitoSans;
    font-size: 14px;
    line-height: 20px;
    color: ${styles.colors.black500};
`
const CheckIcon = styled(PricingIcon)`
    flex-shrink: 0;
    margin-top: 2px;
    color: ${styles.colors.primary600};
`
const FeatureText = styled.span`
    min-width: 0;
    cursor: help;
    text-decoration: underline dotted ${styles.colors.disabledState};
    text-underline-offset: 3px;
    outline: none;

    strong {
        font-weight: 700;
        color: ${styles.colors.black600};
    }
`

export default PlanFeatureList
